import Select from 'react-select';
import './CustomerList.css';
import React from 'react';

const EndCustomersDropdown = (props) => {
  const { data = [], disabled, reset } = props;
  const dataForEndCustomerOptions = [];

  const attributes = {
    ...props,
    classNamePrefix: 'customer',
    options: dataForEndCustomerOptions,
    isMulti: true,
  };

  let className = 'customer-dropdown-container';
  if (disabled) {
    attributes.isDisabled = disabled;
    className = 'paddingTop';
  }

  if (reset) {
    attributes.value = null;
  }

  // eslint-disable-next-line
  data.map((endcustomer) => {
    dataForEndCustomerOptions.push({ value: endcustomer.text.destinationId, label: endcustomer.text.endCustomer });
  });

  return (
    <div className={className}>
      <Select {...attributes} />
    </div>
  );
};

export default EndCustomersDropdown;
